export const FIELDMESSAGE = "required";
export const SUCCESSMESSAGE = "System successfully saved the information";
export const ERRORMESSAGE ="should not be empty in ";
export const FORMAT_VALIDATION_ERR  = "X.XXXXXX should be the format for T-Bill Rate";
export const REQUIRED_ERR = "Rate is Required";
export const UNSAVED_CHANGES_STR = 'There are unsaved changes. Do you want to continue?';
